import styled from 'styled-components'
import { BarryUIColorKey } from '../../theme'

const Separator = styled.div<{ marT?: number; marB?: number }>`
  width: 100%;
  background: ${(props) => props.theme.semantics.zap.stroke.tertiary};
  height: 1px;
  margin-top: ${(props) => props.marT ?? 0}px;
  margin-bottom: ${(props) => props.marB ?? 0}px;
`

type VerticalSeparatorProps = {
  marL?: number
  marR?: number
  c?: BarryUIColorKey
}

export const VerticalSeparator = styled.div<VerticalSeparatorProps>`
  height: 100%;
  width: 1px;
  background-color: ${(props) => props.theme.semantics.zap.stroke.secondary};
  ${({ c, theme }) => {
    if (!c) return ''
    const [parentKey, childKey] = c.split('-')
    const color = theme.semantics.zap?.[parentKey]?.[childKey]
    if (!color) return ''
    return `
        background-color: ${color};
        `
  }}
  margin-left: ${(props) => props.marL ?? 0}px;
  margin-right: ${(props) => props.marR ?? 0}px;
`

export default Separator
